import React from 'react'
import { Link } from 'react-router-dom'

export default function CommonBanner() {
    return (
        <div className='section-padding 1440:py-[5rem]  999:py-[3.8rem] 768:py-[2.9rem] py-[25px]'>
            <div className=' flex items-start justify-start 1650:text-[3.875rem] 1440:text-[3.2rem] 1350:text-[2.9rem] 768:text-[2.4rem] 600:text-[2rem] text-[1.8rem]  1550:gap-[1.8125rem]  1350:gap-[1.3rem] 768:gap-[1.2rem] 600:gap-[1rem] gap-[0.9rem]'>
                <div className='1550:mt-[1.875rem] 1350:mt-[1.25rem] 999:mt-[1.1rem] 600:mt-[1rem] mt-[0.5rem]'>
                    <Link className='' to='/'>
                    <svg className='w-[1rem] h-[1.8125rem]' width="16" height="29" viewBox="0 0 16 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="Vector" d="M14.335 2L1.99996 14.335L14.335 26.67" stroke="#999CA4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    </Link>
                </div>

                <div>
                    <p>Lorem ipsum dolor sit amet consectetur. </p>
                    <p className='768:pr-[53px] 1650:1350:text-[1.5rem]  1350:text-[1.2rem] 768:text-[1.1rem] 600:text-[1rem] text-[1.2rem] secondary-text font-[450]  leading-[1.20] pt-[.9375rem] pb-[.625rem]'>Lorem ipsum dolor sit amet consectetur. Pulvinar nunc egestas eleifend in vel erat. Massa velit sem aenean ultricies pellentesque est auctor duis placerat. Aliquet sed mi ullamcorper etiam non eu risus purus platea.</p>
                </div>
            </div>
            <div className='w-full 1550:pt-[2.5rem] 1350:pt-[2.3rem] 999:pt-[2.1rem] 600:pt-[1.8rem] pt-[15px] '>
                <div className='section-primary-bg rounded-[30px] 1550:h-[34.375rem] 1350:h-[29rem] 999:h-[26rem] 600:h-[22rem] h-[60vw] w-full'>

                </div>
            </div>
        </div>
    )
}
